import {
  DEFAULT_COSTS,
  //   DEFAULT_US_ZIP_CODE,
  STYLE_TO_EFFICIENCY,
} from '@/lib/constants';
import { getFuelCosts } from '@/lib/fuelCost/getFuelCosts';
// import {
//   CombinedJDIncentive,
//   JDPowerIncentive,
// } from '@/lib/schema/incentives/types';
import { useMutation } from '@tanstack/react-query';
import clsx from 'clsx';
import { useSearchParams } from 'next/navigation';
import { Suspense, useState } from 'react';
import Button, { ButtonVariants } from '@/components/atoms/Button/Button';
import FormSelect from '@/components/molecules/FormSelect';
import { DropdownMenuItemVariants } from '@/components/molecules/DropdownMenuItem';
import Footer from './Footer';
import { CTAOverlay, DisclaimerOverlay } from './Overlays';
import IframeSwitcher from './IframeSwitcher';

// Custom Bolt Icon Component
const CustomBoltIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="63"
    height="68"
    viewBox="0 0 63 68"
    fill="none"
    className={className}
  >
    <path
      d="M32.5566 3.44238C33.8942 2.0789 35.9716 1.73225 37.6865 2.59766L37.8496 2.68457C39.4648 3.58624 40.3461 5.4084 40.0312 7.2373L39.9951 7.41992L36.0996 25.458H55.8555C57.5804 25.458 59.1541 26.4648 59.8652 28.043C60.5327 29.5245 60.3178 31.2407 59.333 32.5088L59.126 32.7559L30.5713 64.4229C29.2826 65.852 27.2177 66.2701 25.4805 65.4824L25.3135 65.4023C23.5395 64.507 22.5838 62.5299 23.0049 60.5801L26.9004 42.542H7.14453C5.52735 42.542 4.0434 41.6571 3.27832 40.2461L3.13477 39.957C2.4229 38.3768 2.71488 36.5298 3.87402 35.2441L32.4287 3.57715L32.5566 3.44238Z"
      fill="#74E437"
    />
    <path
      d="M32.5566 3.44238C33.8942 2.0789 35.9716 1.73225 37.6865 2.59766L37.8496 2.68457C39.4648 3.58624 40.3461 5.4084 40.0312 7.2373L39.9951 7.41992L36.0996 25.458H55.8555C57.5804 25.458 59.1541 26.4648 59.8652 28.043C60.5327 29.5245 60.3178 31.2407 59.333 32.5088L59.126 32.7559L30.5713 64.4229C29.2826 65.852 27.2177 66.2701 25.4805 65.4824L25.3135 65.4023C23.5395 64.507 22.5838 62.5299 23.0049 60.5801L26.9004 42.542H7.14453C5.52735 42.542 4.0434 41.6571 3.27832 40.2461L3.13477 39.957C2.4229 38.3768 2.71488 36.5298 3.87402 35.2441L32.4287 3.57715L32.5566 3.44238Z"
      fill="white"
      fillOpacity="0.2"
    />
    <path
      d="M32.5566 3.44238C33.8942 2.0789 35.9716 1.73225 37.6865 2.59766L37.8496 2.68457C39.4648 3.58624 40.3461 5.4084 40.0312 7.2373L39.9951 7.41992L36.0996 25.458H55.8555C57.5804 25.458 59.1541 26.4648 59.8652 28.043C60.5327 29.5245 60.3178 31.2407 59.333 32.5088L59.126 32.7559L30.5713 64.4229C29.2826 65.852 27.2177 66.2701 25.4805 65.4824L25.3135 65.4023C23.5395 64.507 22.5838 62.5299 23.0049 60.5801L26.9004 42.542H7.14453C5.52735 42.542 4.0434 41.6571 3.27832 40.2461L3.13477 39.957C2.4229 38.3768 2.71488 36.5298 3.87402 35.2441L32.4287 3.57715L32.5566 3.44238Z"
      stroke="#F9FAFB"
      strokeWidth="3.75"
      strokeLinejoin="round"
    />
  </svg>
);

// Custom Gas Icon Component
const CustomGasIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="54"
    height="70"
    viewBox="0 0 54 70"
    fill="none"
    className={className}
  >
    <path
      d="M28.2363 4.67969C29.2231 5.67475 34.0147 10.2457 36.7256 13.3438C39.0744 16.028 41.1534 18.5446 42.9619 20.8633L43.7207 21.8447L43.7471 21.8799L43.7725 21.916C46.0263 25.1628 47.9502 28.7232 49.5488 32.5459C51.1562 36.3895 52 39.8199 52 42.8379C52 47.2961 50.8411 51.4211 48.5967 55.2734L48.5947 55.2764C46.3702 59.0789 43.2053 62.2363 39.4082 64.4424L39.4092 64.4434C35.539 66.7078 31.3554 67.875 26.8887 67.875C22.4198 67.8749 18.2772 66.7068 14.4482 64.4385C10.857 62.3109 7.98213 59.4586 5.79297 55.9854L5.36426 55.2822C3.10482 51.4527 2 47.2767 2 42.8379C2.00002 39.4883 2.98584 35.685 5.00781 31.46L5.37109 30.6797C7.2072 26.7934 9.36095 23.1487 11.7949 19.7471L12.2822 19.0742C14.7254 15.7353 17.2914 12.7885 19.9443 10.1992L25.5918 4.66113L26.9229 3.35547L28.2363 4.67969Z"
      fill="#38393A"
      stroke="#F9FAFB"
      strokeWidth="3.75"
    />
  </svg>
);

interface HeaderProps {
  savings: number;
  overlayOpen: boolean;
  isEv: boolean;
}

const Header: React.FC<HeaderProps> = ({ savings, overlayOpen, isEv }) => {
  return (
    <div
      className={clsx(
        'flex flex-col items-center gap-xs bg-brandMidnight p-xs sm:p-s md:p-l text-white s:flex-row',
        { 'ml:px-xl': overlayOpen, 'ml:px-3xl': !overlayOpen }
      )}
    >
      <div className="text-center text-body1Regular sm:text-h4Regular ml:text-h3Regular">
        {isEv ? (
          <>
            <span>Gas savings </span>
            <span className="relative text-body1SemiBold sm:text-h4SemiBold text-brandElectric">
              ${savings.toLocaleString()}
              <span className="absolute -right-1 -top-1 sm:-right-2 sm:-top-2 text-xs">
                *
              </span>
            </span>
          </>
        ) : (
          'Switch to an EV'
        )}
      </div>
    </div>
  );
};

const GasSavingsSection: React.FC<{
  years: number;
  setYears: (val: number) => void;
  annualMiles: number;
  setAnnualMiles: (val: number) => void;
  cost: { ev: number; gas: number };
  ctaCompleted: boolean;
}> = ({ years, setYears, annualMiles, setAnnualMiles, cost, ctaCompleted }) => {
  return (
    <div className="flex min-h-0 flex-1 flex-col justify-center p-xs sm:p-s md:p-l lg:p-xl">
      <div className="flex flex-col items-center gap-s sm:gap-l md:gap-xl">
        <div className="flex flex-col gap-xs sm:gap-s md:gap-l">
          <div className="flex w-full items-center justify-center">
            <div className="flex flex-col items-center gap-xs sm:gap-s">
              <div className="flex items-center justify-center">
                <CustomBoltIcon className="h-[40px] w-[38px] sm:h-[60px] sm:w-[56px] md:h-[80px] md:w-[76px]" />
              </div>
              <div className="flex flex-col items-center">
                <div className="text-body1SemiBold sm:text-h4SemiBold text-gray-800">
                  ${cost.ev.toLocaleString()}
                  <span className="text-body1Regular sm:text-h4Regular">
                    /yr
                  </span>
                </div>
              </div>
            </div>
            <div className="mx-xs sm:mx-s md:mx-l flex flex-col items-center">
              <div className="text-body2Medium text-gray-600">vs</div>
            </div>
            <div className="flex flex-col items-center gap-xs sm:gap-s">
              <div className="flex items-center justify-center">
                <CustomGasIcon className="h-[40px] w-[34px] sm:h-[60px] sm:w-[51px] md:h-[80px] md:w-[68px]" />
              </div>
              <div className="flex flex-col items-center">
                <div className="text-body1SemiBold sm:text-h4SemiBold text-gray-800">
                  ${cost.gas.toLocaleString()}
                  <span className="text-body1Regular sm:text-h4Regular">
                    /yr
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {ctaCompleted && (
          <div className="w-full max-w-md">
            <div className="flex flex-col gap-s sm:gap-l md:flex-row">
              <div className="flex flex-1 flex-col gap-xs sm:gap-s">
                <div className="text-microRegular sm:text-body2Regular text-neutral-800">
                  Ownership years
                </div>
                <IframeSwitcher
                  options={[
                    { label: '1', value: '1' },
                    { label: '2', value: '2' },
                    { label: '3', value: '3' },
                    { label: '4', value: '4' },
                    { label: '5', value: '5' },
                  ]}
                  value={years.toString()}
                  onChange={(val) => setYears(parseInt(val, 10))}
                  aria-label="Ownership years"
                />
              </div>

              <div className="flex flex-1 flex-col gap-xs sm:gap-[6px]">
                <div className="flex justify-between text-microRegular sm:text-body2Regular">
                  <div className="text-neutral-800">Annual mileage</div>
                </div>
                <FormSelect
                  variant={DropdownMenuItemVariants.SingleSelect}
                  options={[
                    { text: '5,000', value: '5000' },
                    { text: '10,000', value: '10000' },
                    { text: '15,000', value: '15000' },
                    { text: '20,000', value: '20000' },
                    { text: '25,000', value: '25000' },
                    { text: '30,000', value: '30000' },
                  ]}
                  value={[annualMiles.toString()]}
                  onChange={(values) => setAnnualMiles(parseInt(values[0], 10))}
                  showCount={false}
                  placeholder="Select mileage"
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

interface SavingsToolV2Props {
  vin: string;
  isGas: boolean;
  condition: string;
  bodyType: string;
  knownInventory: boolean;
  defaultZip?: string;
  rebates?: boolean;
}

const SavingsToolV2Component: React.FC<SavingsToolV2Props> = ({
  vin,
  isGas,
  bodyType,
  knownInventory,
}) => {
  const defaultOverlays = {
    incentiveInfo: false,
    disclaimer: false,
    location: false,
    cta: false,
  };
  const [overlays, setOverlays] = useState(defaultOverlays);
  const overlayOpen = Object.values(overlays).some((val) => val);

  const [years, setYears] = useState(5);
  const [annualMiles, setAnnualMiles] = useState(10000);
  const [ctaCompleted, setCtaCompleted] = useState(false);

  const gasPrice = Number(DEFAULT_COSTS.gasolineCost);
  const electricityPrice = Number(DEFAULT_COSTS.electricityCost);
  const body = bodyType in STYLE_TO_EFFICIENCY ? bodyType : 'Sedan';
  const gasMileage = STYLE_TO_EFFICIENCY[body].gas;
  const evRate = STYLE_TO_EFFICIENCY[body].electric;

  const fuelCosts = getFuelCosts({
    carType: body,
    electricityCost: electricityPrice,
    gasolineCost: gasPrice,
    mileagePerYear: annualMiles,
    years,
    fuelType: 'Electric',
  });

  const gasCost = fuelCosts.gasCost * years;
  const evCost = fuelCosts.altCost * years;
  const fuelSavings = fuelCosts.totalSavings;

  const searchParams = useSearchParams();
  const dealerName = searchParams?.get('name');
  const dealerEmail = searchParams?.get('contact');

  const isEv = knownInventory && !isGas;

  const [userName, setUserName] = useState('');
  const [userEmail, setUserEmail] = useState('');
  const [userPhone, setUserPhone] = useState('');

  const {
    isError: ctaError,
    isSuccess: ctaSuccess,
    isPending: ctaPending,
    reset: ctaReset,
    mutate,
  } = useMutation<
    unknown,
    Error,
    {
      vin: string;
      dealerName: string;
      dealerEmail: string;
      userName: string;
      userEmail: string;
      userPhone: string;
    }
  >({
    mutationFn: async (vars) => {
      const res = await fetch(`/api/partner/iframe`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          vin: vars.vin,
          dealership_name: vars.dealerName,
          dealership_email: vars.dealerEmail,
          customer_name: vars.userName,
          customer_email: vars.userEmail,
          customer_phone_number: vars.userPhone,
        }),
      });

      if (!res.ok) {
        throw new Error();
      }
    },
    onSettled: () => {
      setTimeout(() => {
        setOverlays(defaultOverlays);
        ctaReset();
      }, 2000);
    },
    onSuccess: () => {
      setCtaCompleted(true);
    },
  });

  return (
    <div className="min-h-iframe flex flex-col rounded-small border-[2px] border-neutral-200 bg-white">
      <Header savings={fuelSavings} overlayOpen={overlayOpen} isEv={isEv} />
      {!overlayOpen && (
        <div className="flex flex-1 flex-col">
          {!isEv && (
            <div className="px-xs py-xs sm:px-s sm:py-s md:px-l md:py-l text-microNormal sm:text-body2Regular text-neutral-900 ml:px-3xl">
              Drive electric to save on gas, maintenance, emissions, and qualify
              for incentives and rebates.
            </div>
          )}

          {/* Gas Savings Layout */}
          <div className="flex min-h-0 flex-1">
            {/* Gas Savings */}
            <div className="flex flex-1 flex-col bg-white">
              <GasSavingsSection
                years={years}
                setYears={setYears}
                annualMiles={annualMiles}
                setAnnualMiles={setAnnualMiles}
                cost={{ ev: evCost, gas: gasCost }}
                ctaCompleted={ctaCompleted}
              />
            </div>
          </div>

          {/* CTA Button at bottom of iframe - only show if CTA not completed */}
          {!ctaCompleted && (
            <div className="px-xs py-xs sm:px-s sm:py-s md:px-l md:py-l">
              <Button
                aria-label="Personalize savings"
                variant={ButtonVariants.Tertiary}
                onClick={() => setOverlays({ ...defaultOverlays, cta: true })}
              >
                Personalize savings
              </Button>
            </div>
          )}
        </div>
      )}

      {overlayOpen && (
        <div className="flex-auto">
          {overlays.disclaimer && (
            <DisclaimerOverlay
              gasDisclaimerInfo={{
                bodyType: body,
                rate: { gas: gasMileage, ev: evRate },
                miles: annualMiles,
                price: { gas: gasPrice, ev: electricityPrice },
              }}
              onClose={() => setOverlays(defaultOverlays)}
            />
          )}
          {overlays.cta && (
            <CTAOverlay
              name={userName}
              onChangeName={setUserName}
              email={userEmail}
              onChangeEmail={setUserEmail}
              phone={userPhone}
              onChangePhone={setUserPhone}
              onSubmit={() =>
                mutate({
                  vin,
                  dealerName: dealerName ?? '',
                  dealerEmail: dealerEmail ?? '',
                  userName,
                  userEmail,
                  userPhone,
                })
              }
              success={ctaSuccess}
              loading={ctaPending}
              error={ctaError}
              onClose={() => setOverlays(defaultOverlays)}
            />
          )}
        </div>
      )}
      <Footer
        overlayOpen={overlayOpen}
        onClickDisclaimerPrompt={() =>
          setOverlays({ ...defaultOverlays, disclaimer: true })
        }
      />
    </div>
  );
};

const SavingsToolV2 = (props: SavingsToolV2Props) => (
  <Suspense>
    <SavingsToolV2Component {...props} />
  </Suspense>
);

export default SavingsToolV2;
